
import {map,  tap } from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import * as _ from 'lodash';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config.service';
import { DataStoreService } from '../../../core/services/datastore.service';
import { EditModeService } from '../../../core/services/edit-mode.service';
import { HttpStatus } from '../../../core/model/http-status-enum.model';
import { Injectable } from '@angular/core';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { QueryViewLocoData } from '../model/query-view-locomotive-data.model';
import { QueryViewTrainData } from '../model/query-view-train-data.model';
import { Router } from '@angular/router';
import { Tab } from '../../../core/model/tab.model';
import { TabData } from '../../../core/model/tab-data.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';
import { formatDate } from '@angular/common';
import { LocoDetail } from '../../../core/model/loco-detail.model';
/**
 * @export
 * @class QueryViewService
 */
@Injectable()
export class QueryViewService {
  loadData: Observable<any>;
  private LOCO_RESOURCE_URL = '/locomotives/query';
  private TRAINS_RESOURCE_URL = '/trains/query';
  private configData: any;
  private apiUrl: string;
  private loadDataBS: BehaviorSubject<any>;

  /**
   * Creates an instance of QueryViewService.
   * @param {HttpClient} http
   * @param {LmsLoaderService} lmsLoaderService
   * @param {Router} router
   * @param {ConfigService} configService
   * @param {DataStoreService} dataStoreService
   * @param {EditModeService} editModeService
   * @param {LmsLoggerService} lmsLoggerService
   * @param {AppUtilityService} appUtilityService
   * @memberof QueryViewService
   */
  constructor(private http: HttpClient, private lmsLoaderService: LmsLoaderService, private router: Router, private configService: ConfigService, private dataStoreService: DataStoreService, private editModeService: EditModeService,
    private lmsLoggerService: LmsLoggerService,
    private appUtilityService: AppUtilityService,
    private lmsModuleService: LmsModuleService
  ) {
    this.loadDataBS = <BehaviorSubject<any>>new BehaviorSubject({});
    this.loadData = this.loadDataBS.asObservable();
    this.configData = this.configService.getConfigData();
    this.apiUrl = this.configData.urls.API_URL;
  }

  /**
   * load train and loco data
   * @param {Tab} tab
   * @param {Object} requestData
   * @param {string} typeName
   * @returns
   * @memberof QueryViewService
   */
  load(tab: Tab, requestData: Object, typeName: string) {

    if (!typeName) {
      // if coming on this condition then we show last store data
      const tabData = <TabData>this.dataStoreService.getValue(tab);
      if (tabData) {
        if (tab && tab.queryView && tab.queryView.typeSearch === 'Trains') {
          this.loadDataBS.next(tabData.data[tab.subType]);
        } else {
          this.lmsLoaderService.showLoader();
          this.subscribeLocoData(tabData.data[tab.subType], tab, false);
        }
        // this.loadDataBS.next(tabData.data[tab.subType]);
        // this.lmsLoaderService.hideLoader();
      }
      return true;
    } else {
      if (!(tab.subTypeDetail && tab.subTypeDetail.data && tab.subTypeDetail.data.message)) {
        this.loadDataBS.next({ data: [] });
      }
    }
    // else we calculate that from which action we need to do
    if (typeName === 'Trains') {
      this.loadTrainData(tab, requestData);
    } else {
      this.loadLocoData(tab, requestData);
    }
  }

  /**
   * This method loads Train Data
   * @param {Tab} tab
   * @param {Object} requestData
   * @memberof QueryViewService
   */
  loadTrainData(tab: Tab, requestData: Object) {
    this.lmsLoaderService.showLoader();
    requestData = this.setRequestData(requestData, 'trains');
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('QueryViewService=>loadTrainData service call starts');
    this.http.post(`${this.apiUrl}${this.TRAINS_RESOURCE_URL}?opr=INQU`, JSON.stringify(requestData), options).pipe(
      tap(() => this.lmsLoggerService.logInfo('QueryViewService=>loadTrainData service call ends'))
    )
      .subscribe(data => {
        this.subscribeTrainData(data, tab);
      },
      error => {
        this.lmsLoaderService.hideLoader();
        const lLocoDetail = ({
          httpStatus: error.status,
          errorMessage: this.appUtilityService.getHttpErroMessage(error, false)
        });

        this.loadDataBS.next(lLocoDetail);
        tab.subTypeDetail.data.message = lLocoDetail.errorMessage;
        this.lmsModuleService.updateSelectedTab(tab);
        this.lmsLoggerService.logError('QueryViewTrainDataService => load()',
          this.appUtilityService.getHttpErroMessage(error, false));
      });
  }

  /**
     * Generate TMC Field
     * @param {string} perf
     * @param {string} trainStatus
     * @param {string} trainTmcTerminal
     * @returns {string}
     * @memberof QueryViewService
     */
  private generateTMC(perf: string, trainStatus: string, trainTmcTerminal: string): string {
    let status = '';
    if ('TD' === trainStatus) {
      status = 'Actual Departure';
    } else if ('TA' === trainStatus) {
      status = 'Actual Arrival';
    } else {
      status = '';
    }
    let city;
    city = this.appUtilityService.getTerminalCityState(trainTmcTerminal);
    if ('-' === city) {
      city = '';
    }
    let time = '';
    let timeStatus = '';
    if (perf) {
      if ('00\'00"' === perf.substring(0, 6)) {
        timeStatus = '';
      } else if ('00\'00"' !== perf.substring(0, 6) && 'L' === perf.substring(perf.length - 1, perf.length)) {
        timeStatus = 'Late';
      } else if ('00\'00"' !== perf.substring(0, 6) && 'L' !== perf.substring(perf.length - 1, perf.length)) {
        timeStatus = 'Advanced';
      }
      time = perf.substring(0, perf.length - 1) + ' ' + timeStatus;
    }

    return status + ' ' + city + ' ' + time;
  }
  /**
   * @param {*} data
   * @param {Tab} tab
   * @memberof QueryViewService
   */
  subscribeTrainData(data: any, tab: Tab) {
    if (data && data.priorityCode) {
      const pCode = parseInt(data.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        const dataArray = data.data;
        const dataArrayLength = dataArray.length;
        for (let index = dataArrayLength - 1; index >= 0; index--) {
          const element = dataArray[index];
          if (element.trainId) {
            data.data[index]['locoData'] = _.filter(element['locoData'], (value) => { return value !== ''; });
            data.data[index]['tmc'] = this.generateTMC(data.data[index].perf, data.data[index].trainStatus, data.data[index].trainTmcTerminal);
          } else {
            data.data.splice(index, 1);
          }
        }
        data['typeSearch'] = 'Trains';
        const tabData = <TabData>({
          id: tab.id,
          subType: tab.subType
        });
        tabData.data = tabData.data ? tabData.data : {};
        tabData.data[tab.subType] = data;
        data.httpStatus = HttpStatus.OK;
        data.tabId = tab.id;
        data.errorMessage = '';
        tab.subTypeDetail.data.message = '';
        this.lmsLoaderService.hideLoader();
        this.dataStoreService.putValue(tab, tabData);
        this.editModeService.setEditResetMode(false);
        this.loadDataBS.next(data);
      } else {
        this.lmsLoaderService.hideLoader();
        const lLocoDetail = ({
          httpStatus: 400,
          errorMessage: data.messageText
        });
        tab.subTypeDetail.data.message = lLocoDetail.errorMessage;
        this.lmsModuleService.updateSelectedTab(tab);
        this.loadDataBS.next(lLocoDetail);
        this.lmsLoggerService.logError('LocoDataService => load()',
          data.messageText);
      }
    }
  }


  /**
   * This method load Loco Data
   * @param {Tab} tab
   * @param {Object} requestData
   * @memberof QueryViewService
   */
  loadLocoData(tab: Tab, requestData: Object) {
    this.lmsLoaderService.showLoader();
    requestData = this.setRequestData(requestData, 'locos');
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('QueryViewService=>loadLocoData service call starts');
    this.http.post(`${this.apiUrl}${this.LOCO_RESOURCE_URL}?opr=INQU`, JSON.stringify(requestData), options).pipe(
      tap(() => this.lmsLoggerService.logInfo('QueryViewService=>loadLocoData service call ends'))
    )
      .subscribe(data => {
        this.subscribeLocoData(data, tab, true);
      },
      error => {
        this.lmsLoaderService.hideLoader();
        const lLocoDetail = ({
          httpStatus: error.status,
          errorMessage: this.appUtilityService.getHttpErroMessage(error, false)
        });
        this.loadDataBS.next(lLocoDetail);
        tab.subTypeDetail.data.message = lLocoDetail.errorMessage;
        this.lmsModuleService.updateSelectedTab(tab);
        this.lmsLoggerService.logError('QueryViewLocoDataService => load()',
          this.appUtilityService.getHttpErroMessage(error, false));
      });
  }

  /**
   * This method subscribes locoData
   * @param {*} data
   * @param {Tab} tab
   * @memberof QueryViewService
   */
  subscribeLocoData(data: any, tab: Tab, fromAPI: boolean) {
    if (data && data.priorityCode) {
      const pCode = parseInt(data.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        const dataArray = data.data;
        const dataArrayLength = dataArray.length;
        for (let index = dataArrayLength - 1; index >= 0; index--) {
          const element = dataArray[index];
          if (fromAPI) {
            if (element.locomotiveId) {
              data.data[index]['milesRemaining'] = data.data[index]['milesRemaining'] ? parseInt(data.data[index]['milesRemaining'], 10) : '-';
              data.data[index]['fuelLevel'] = data.data[index]['fuelLevel'] ? parseInt(data.data[index]['fuelLevel'], 10) : '-';
              data.data[index]['locomotiveId'] = this.appUtilityService.UIformatLocomotiveId(data.data[index]['locomotiveId']);
            } else {
              data.data.splice(index, 1);
            }
          }
        }
        data['typeSearch'] = 'Locomotives';
        const tabData = <TabData>({
          id: tab.id,
          subType: tab.subType
        });
        tabData.data = tabData.data ? tabData.data : {};
        tabData.data[tab.subType] = data;
        data.httpStatus = HttpStatus.OK;
        data.tabId = tab.id;
        data.errorMessage = '';
        tab.subTypeDetail.data.message = '';
        setTimeout(() => {
          this.lmsLoaderService.hideLoader();
        }, 0);
        this.dataStoreService.putValue(tab, tabData);
        this.editModeService.setEditResetMode(false);
        this.loadDataBS.next(data);
      } else {
        this.lmsLoaderService.hideLoader();
        const lLocoDetail = {
          httpStatus: 400,
          errorMessage: data.messageText
        };
        this.loadDataBS.next(lLocoDetail);
        tab.subTypeDetail.data.message = lLocoDetail.errorMessage;
        this.lmsModuleService.updateSelectedTab(tab);
        this.lmsLoggerService.logError('QueryViewLocoDataService => load()', data.messageText);
      }
    }
  }


  /**
   * @private
   * @param {any} stringName
   * @returns
   * @memberof QueryViewService
   */
  private setRequestData(requestData, typeName) {
    requestData = requestData.filters;
    const multiFeatureCodes = _.filter([requestData[0].features1, requestData[0].features2, requestData[0].features3], (value) => { return value !== ''; });
    const excludeFeatureCodes = [];
    if (multiFeatureCodes.length) {
      for (let index = 0; index < 3; index++) {
        const element = multiFeatureCodes[index];
        excludeFeatureCodes.push(requestData[0][`features${index + 1}Exclude`] ? 'Y' : 'N');
      }
    }
    const mainObject = {
      // geo
      systemLevel: requestData[2].selectedGeoView === 'system' ? 'Y' : '',
      deskId: requestData[2].selectedGeoView === 'desk' ? requestData[2].selectedGeoDescriptions : '',
      oprtngZoneCode: requestData[2].selectedGeoView === 'operating Zone' ? requestData[2].selectedGeoDescriptions : '',
      oprtngRegionCode: requestData[2].selectedGeoView === 'operating Region' ? requestData[2].selectedGeoDescriptions : '',
      // commodity tab data
      intermodalComm: requestData[3].intermodalComm ? 'I' : '',
      grainComm: requestData[3].grainComm ? 'G' : '',
      coalComm: requestData[3].coalComm ? 'C' : '',
      bulkComm: requestData[3].bulkComm ? 'M' : '',
      localComm: requestData[3].localComm ? 'L' : '',
      autoComm: requestData[3].autoComm ? 'A' : '',
      emptyComm: requestData[3].emptyComm ? 'E' : '',
      workTrainComm: requestData[3].workTrainComm ? 'W' : '',
      extraTrainComm: requestData[3].extraTrainComm ? 'X' : '',
      passengerComm: requestData[3].passengerComm ? 'P' : '',
      foreignComm: requestData[3].foreignComm ? 'Z' : '',
      otherComm: requestData[3].otherComm ? 'O' : '',
      liteEngComm: requestData[3].liteEngComm ? 'T' : '',
      qMerchandise: requestData[3].qMerchandise ? 'Q' : '',
      // locomotives related
      milesToEmpty: (typeName === 'locos' && requestData[0].milesToEmptyCheck) ? (0 !== requestData[0].milesToEmpty ? this.appUtilityService.leftPadWithZero(requestData[0].milesToEmpty, '0', 4) : '0000') : '',
      hoursIdle: (typeName === 'locos' && requestData[0].hoursIdleCheck) ? (0 !== requestData[0].hoursIdle ? this.appUtilityService.leftPadWithZero(requestData[0].hoursIdle, '0', 3) : '000') : '',
      permTag: (typeName === 'locos' && requestData[0].permTag) ? requestData[0].permTag : '',
      locoTag: (typeName === 'locos' && requestData[0].locoTag) ? requestData[0].locoTag : '',
      classCode: (typeName === 'locos' && requestData[0].classCode) ? requestData[0].classCode : '',
      classCategory: (typeName === 'locos' && requestData[0].classCategory) ? requestData[0].classCategory : '',
      incidentCode: (typeName === 'locos' && requestData[0].incidentCode) ? requestData[0].incidentCode : '',
      questionMark: (typeName === 'locos' && requestData[0].questionMark) ? '?' : '',
      multiFeatureCodes: multiFeatureCodes,
      excludeFeatureCodes: excludeFeatureCodes,
      // offline
      inclOfflineUnits: (typeName === 'locos' && requestData[0].offline === 'include') ? 'Y' : '',
      offlineOnly: (typeName === 'locos' && requestData[0].offline === 'only') ? 'Y' : '',
      // stored
      inclSotredUnits: (typeName === 'locos' && requestData[0].stored === 'include') ? 'Y' : '',
      storedUnitsOnly: (typeName === 'locos' && requestData[0].stored === 'only') ? 'Y' : '',
      // for service due selection
      serviceDuePast: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'serviceDue' && (requestData[0].allPastDue || requestData[0].withinDaysRadio)) ?
        (requestData[0].allPastDue ? 'ALLP' : this.setPlusMinusWithLimit(requestData[0].withinDays, 4)) : '',
      serviceDueGreater: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'serviceDue' && requestData[0].daysRadio) ? this.setPlusMinusWithLimit(requestData[0].days, 4) : '',
      // for 33 days selection
      mechInspecPast: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === '33Day' && (requestData[0].allPastDue || requestData[0].withinDaysRadio)) ?
        (requestData[0].allPastDue ? 'ALLP' : this.setPlusMinusWithLimit(requestData[0].withinDays, 4)) : '',
      mechInspecGreater: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === '33Day' && requestData[0].daysRadio) ? this.setPlusMinusWithLimit(requestData[0].days, 4) : '',
      // for  airflow selection
      airFlowMeterPast: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'airFlow' && (requestData[0].allPastDue || requestData[0].withinDaysRadio)) ?
        (requestData[0].allPastDue ? 'ALLP' : this.setPlusMinusWithLimit(requestData[0].withinDays, 4)) : '',
      airFlowMeterGreater: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'airFlow' && requestData[0].daysRadio) ? this.setPlusMinusWithLimit(requestData[0].days, 4) : '',
      // for qdays selection
      qdueDays: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'qDue' && (requestData[0].allPastDue || requestData[0].withinDaysRadio)) ?
        (requestData[0].allPastDue ? 'ALLP' : this.setPlusMinusWithLimit(requestData[0].withinDays, 4)) : '',
      qdueGreater: (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'qDue' &&
        requestData[0].daysRadio) ?
        this.setPlusMinusWithLimit(requestData[0].days, 4) : '',
      allocOperatingZone: (typeName === 'locos' && requestData[0].yardLocal) ? requestData[0].yardLocal : '',
      allocStation: (typeName === 'locos' && requestData[0].yardLocalSelected) ? requestData[0].yardLocalSelected : '',
      // trains
      dueOutHour: (typeName === 'trains' && requestData[1].trainCheck === 'dueOutHour') ? (0 !== requestData[1].dueOutHourValue ? this.appUtilityService.leftPadWithZero(requestData[1].dueOutHourValue, '0', 3) : '000') : '',
      minUnit: (typeName === 'trains' && requestData[1].trainCheck === 'notMovingPerGps') ? (0 !== requestData[1].minUnit ? this.appUtilityService.leftPadWithZero(requestData[1].minUnit, '0', 2) : '00') : '',
      maxUnit: (typeName === 'trains' && requestData[1].trainCheck === 'notMovingPerGps') ? (0 !== requestData[1].maxUnit ? this.appUtilityService.leftPadWithZero(requestData[1].maxUnit, '0', 2) : '00') : '',
      minGpsHour: (typeName === 'trains' && requestData[1].trainCheck === 'notMovingPerGps') ? (0 !== requestData[1].minGpsHour ? this.appUtilityService.leftPadWithZero(requestData[1].minGpsHour, '0', 3) : '000') : '',
      maxGpsHour: (typeName === 'trains' && requestData[1].trainCheck === 'notMovingPerGps') ? (0 !== requestData[1].maxGpsHour ? this.appUtilityService.leftPadWithZero(requestData[1].maxGpsHour, '0', 3) : '000') : '',
      locoUnits: (typeName === 'trains' && requestData[1].trainCheck === 'noOfLocos') ? this.appUtilityService.leftPadWithZero(requestData[1].noOfLocosValue, '0', 2) : '',
      differPlan: (typeName === 'trains' && requestData[1].differPlan) ? requestData[1].differPlan : '',
      hotTrain: (typeName === 'trains' && requestData[1].trainCheck === 'hotTrain') ? requestData[1].hotTrainValue : '',
      allTrains: (typeName === 'trains' && requestData[1].trainCheck === 'allTrains') ? 'Y' : '',
      excludeOrigTrains: (typeName === 'trains' && requestData[1].excludeOriginatingTrains) ? 'Y' : ''
    };
    if (typeName === 'locos' && requestData[0].dueDayAirFlowValue === 'deadDate') {
      let deadDate = '';
      if (requestData[0].allPastDue) {
        deadDate = 'ALLP';
      } else if (requestData[0].daysRadio) {
        deadDate = this.setPlusMinusWithLimit(requestData[0].days, 4);
      } else if (requestData[0].withinDaysRadio) {
        deadDate = this.setPlusMinusWithLimit(requestData[0].withinDays, 4);
      }
      mainObject['deadDate'] = deadDate;
    }

    return mainObject;
  }

  /**
  * @memberOf LocoStatusService
  */
  cleanBehaviourSubject() {

  }

  /**
   * @param {*} data
   * @param {number} limitvalue
   * @returns
   * @memberof QueryViewService
   */
  setPlusMinusWithLimit(data: any, limitvalue: number) {
    const absoluteValue = Math.abs(data);
    return data.toString().length === 4 ? data : ((parseInt(data, 10) < 0 ? '-' : '+') + this.appUtilityService.leftPadWithZero(absoluteValue, '0', 3));
  }


  /**
   * by base app this mwthos trigger so just
   *  create not define any body
   * @memberof QueryViewService
   */
  resetAll() {
  }

  /**
   * @param {any} tabId
   * @memberof QueryViewService
   */
  resetTabData(tabId) {
    this.dataStoreService.removeSubPanel(tabId);
  }

  /**
     * Download Excel
     * @param {TerminalHandlingExcel} terminalHandlingExcel
     * @returns 
     * @memberof TerminalHandlingService
     */
  excelLocoDownload(trainDetailsList: Array<QueryViewLocoData>): void {
    if(trainDetailsList.length == 0) {
      return;
    }
    const wb = XLSX.utils.book_new();
    //datetime in first row
    let title = [
      { v: 'Date: ' + formatDate(new Date(), 'MM/dd/yyyy',"en-US") + ' Time: ' + formatDate(new Date(), 'HH:mm',"en-US"), 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } } 
      }
    ];
    const ws = XLSX.utils.aoa_to_sheet([title]);
    let header = [
      { v: "Locomotive\nInitial", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive\nNumber", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Incident Flag", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Current\nAssignment", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Destination", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Status", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Class",
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Axl",
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "PTC", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last Fueled\nDate", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last Fueled\nLocation", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Miles", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Fuel", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Q Due", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Service Due", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Dead Date", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Next 33 Day", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Next Air\nFlow Calib", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Planned Assignment", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last\nReporting\nDate", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last\nReporting\nTime", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last\nReporting\nType", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last Reporting City\nState", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Operating\nRegion", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Operating\nZone", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Allocation\nStation", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Alloc Type", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Perm\nAlloc", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Alloc\nDiv", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Perm\nTag", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Loco\nTag", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Type of Service", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Next Q\nType", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Remarks", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "OOS", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Partial\nPower", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Trail Only", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Work to Shop", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Notes 1", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Notes 2", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Notes 3", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
    ];
    XLSX.utils.sheet_add_aoa(ws, [header], {origin: 'A2'});
    //setting columns width
    ws['!cols'] = [
      {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:7}, {wch:7}, {wch:12},
      {wch:12}, {wch:7}, {wch:7}, {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:19}, {wch:12},
      {wch:12}, {wch:12}, {wch:19}, {wch:12}, {wch:12}, {wch:12}, {wch:12}, {wch:7}, {wch:7}, {wch:7},
      {wch:7}, {wch:19}, {wch:7}, {wch:7}, {wch:7}, {wch:7}, {wch:58}, {wch:58}, {wch:58},
      {wch:12}, {wch:12}
    ];
    //setting rows height
    ws['!rows'] = [
      {'hpt' : 12},
      {'hpt' : 40},
      {'hpt' : 12}
    ];
    let data = [];
    for(let i=0; i<trainDetailsList.length; i++) {
      let color = trainDetailsList[i].locoIdColor === 'R' ? 'FF0000' : trainDetailsList[i].locoIdColor === 'Y' ? 'FFFF00' : 'FFFFFF';  
      data[i] = [
        { v: trainDetailsList[i].locomotiveId.split(' ')[0], 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].locomotiveId.split(' ')[1].padStart(6, '0'), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].locoIdColor, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' }, fill: { fgColor: { rgb: color } } } 
        },
        { v: trainDetailsList[i].lmsLocation, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].trainDestination, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].status, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].classCode, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].axle, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].ptcEquipped, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: this.formattingToDate(trainDetailsList[i].lastFuelDate, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingToString(trainDetailsList[i].lastFuelDate), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].milesRemaining, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
          t: "n",
          z: '#,##0'
        },
        { v: trainDetailsList[i].fuelLevel, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
          t: "n",
          z: '#,##0' 
        },
        { v: this.formattingDate(trainDetailsList[i].nextQDate, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingDate(trainDetailsList[i].serviceDueDate, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingDate(trainDetailsList[i].deadDate, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingDate(trainDetailsList[i].mechInspecDueDate, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingDate(trainDetailsList[i].airFlowDueDate, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: trainDetailsList[i].plannedAssign, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: this.formattingToDate(trainDetailsList[i].lastReportingDateTime, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingToString(trainDetailsList[i].lastReportingDateTime), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].lastReportingType, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].lastReportingCityState, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].oprtngRegion, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].oprtngZone, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].allocStation, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].allocType, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].permAlloc, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].allocDivision, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].permTag, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].locoTag, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].typeOfService, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].nextQType, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].remarks, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].oosFlag, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].partialPowerFlag, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].trailOnlyFlag, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].workToShopFlag, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].notes[0], 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].notes[1], 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].notes[2], 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
      ];
    }
    XLSX.utils.sheet_add_aoa(ws, data, {origin: 'A3'});
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 38 } }];
    XLSX.utils.book_append_sheet(wb, ws, "Locomotives");
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blobData: Blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
    FileSaver.saveAs(blobData, 'LMS-QueryView' + '.xlsx');
  }

  private formattingDate(date: string, pattern: string, locale: string) : string {
    return date === undefined ? '' :
           date.trim() === '' ? '' :
           formatDate(date, pattern, locale)
  }

  private formattingToDate(date: string, pattern: string, locale: string) : string {
    return date === undefined ? '' :
           date === '' ? '' :
           formatDate(date.split(' ')[0], pattern, locale)
  }

  private formattingToString(info: string) : string {
    return info === undefined ? '' :
           info === '' ? '' :
           info.split(' ')[1];
  }

  /**
       * Download Excel
       * @param {TerminalHandlingExcel} terminalHandlingExcel
       * @returns 
       * @memberof TerminalHandlingService
       */
  excelTrainDownload(trainDetailsList: Array<QueryViewTrainData>): void {
    if(trainDetailsList.length == 0) {
      return;
    }
    const wb = XLSX.utils.book_new();
    //datetime in first row
    let title = [
      { v: 'Date: ' + formatDate(new Date(), 'MM/dd/yyyy',"en-US") + ' Time: ' + formatDate(new Date(), 'HH:mm',"en-US"), 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', vertical: 'center' } } 
      }
    ];
    const ws = XLSX.utils.aoa_to_sheet([title]);
    let header = [
      { v: "Terminal", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Train", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Units", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "ETD", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last\nReporting\nDate", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last\nReporting\nTime", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last\nReporting\nType",
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Last Reporting\nLocation",
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Operating Region", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Operating Zone", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "TMC Status", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 1", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 2", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 3", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 4", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 5", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 6", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 7", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 8", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 9", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
      { v: "Locomotive 10", 
        s: { font: { name: "Arial", sz: 10, bold: true }, alignment: { horizontal: 'center', wrapText: true } } 
      },
    ];
    XLSX.utils.sheet_add_aoa(ws, [header], {origin: 'A2'});
    //setting columns width
    ws['!cols'] = [
      {wch:12}, {wch:12}, {wch:7}, {wch:15}, {wch:12}, {wch:12}, {wch:12}, {wch:15}, {wch:19}, {wch:19},
      {wch:29}, {wch:16}, {wch:16}, {wch:16}, {wch:16}, {wch:16}, {wch:16}, {wch:16}, {wch:16}, 
      {wch:16}, {wch:16}
    ];
    //setting rows height
    ws['!rows'] = [
      {'hpt' : 13},
      {'hpt' : 40},
      {'hpt' : 13}
    ];
    let data = [];
    for(let i=0; i<trainDetailsList.length; i++) {
      data[i] = [
        { v: trainDetailsList[i].terminal, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].trainId, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].units, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].etd, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: this.formattingToDate(trainDetailsList[i].lastReportingDateTime, 'MM/dd/yyyy', "en-US"), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { horizontal: 'right', vertical: 'center' } } 
        },
        { v: this.formattingToString(trainDetailsList[i].lastReportingDateTime), 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].lastReportingType, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].lastReportingCityState, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].oprtngRegion, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].oprtngZone, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].tmc, 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } } 
        },
        { v: trainDetailsList[i].locoData.length > 0 ? trainDetailsList[i].locoData[0] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 1 ? trainDetailsList[i].locoData[1] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 2 ? trainDetailsList[i].locoData[2] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 3 ? trainDetailsList[i].locoData[3] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 4 ? trainDetailsList[i].locoData[4] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 5 ? trainDetailsList[i].locoData[5] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 6 ? trainDetailsList[i].locoData[6] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 7 ? trainDetailsList[i].locoData[7] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 8 ? trainDetailsList[i].locoData[8] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
        { v: trainDetailsList[i].locoData.length > 9 ? trainDetailsList[i].locoData[9] : '', 
          s: { font: { name: "Arial", sz: 10 }, alignment: { vertical: 'center' } },
        },
      ];
    }
    XLSX.utils.sheet_add_aoa(ws, data, {origin: 'A3'});
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 19 } }];
    XLSX.utils.book_append_sheet(wb, ws, "Locomotives");
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blobData: Blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
    FileSaver.saveAs(blobData, 'LMS-QueryView' + '.xlsx');
  }

}
